// @ts-nocheck
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { FC, ReactNode } from "react";
import { css } from "styled-components";

export interface ProductLineMessageInfosBoxProps {
    messages?: Array<ReactNode | string>;
    type?: InfosBoxProps["type"];
}

export interface ProductLineMessageInfosBoxStyles {
    infosBox?: InfosBoxProps;
}

export const productLineMessageInfosBoxStyles: ProductLineMessageInfosBoxStyles = {
    infosBox: {
        size: "small",
        type: "warning",
        extendedStyles: {
            wrapper: {
                css: css`
                    ${spacingStyles(pxToRem(1), pxToRem(1))}
                `,
            },
        },
    },
};

const styles = productLineMessageInfosBoxStyles;

const ProductLineMessageInfosBox: FC<ProductLineMessageInfosBoxProps> = ({ messages, type }) => {
    if (!messages?.length) {
        return null;
    }

    return messages.map((message, index) => (
        <InfosBox {...styles.infosBox} key={index} type={type}>
            {message}
        </InfosBox>
    ));
};

export default ProductLineMessageInfosBox;
